// Version handshake per WASM doc §7.3.
//
// Every bindExample call will include a { coreVersion, oxigraphVersion, shapeSha }
// triple in its telemetry payload. Server rejects calls with stale coreVersion
// (hard error, client must reload); stale shapeSha → server logs warning but
// still processes the call.

export interface KgBrowserVersion {
  /** Semantic version of this package (bumped on API change). */
  coreVersion: string
  /** Upstream Oxigraph npm version (source of WASM). */
  oxigraphVersion: string
  /**
   * Content hash of the SHACL shapes + ontology shard at init time.
   * Populated by the loader after hydration — `"unhydrated"` before init.
   */
  shapeSha: string
}

// Bumped manually when API surface changes. Keep in sync with package.json.
// Sub-step 6 checkpoint build — unversioned-stable, pre-CDN publish.
export const KG_BROWSER_CORE_VERSION = "0.0.1-alpha.0"

// Must match `packages.oxigraph` dep in package.json. Update together.
export const OXIGRAPH_VERSION = "0.5.6"

let currentShapeSha = "unhydrated"

export function setShapeSha(sha: string): void {
  currentShapeSha = sha
}

export function versionInfo(): KgBrowserVersion {
  return {
    coreVersion: KG_BROWSER_CORE_VERSION,
    oxigraphVersion: OXIGRAPH_VERSION,
    shapeSha: currentShapeSha,
  }
}
